export default __webpack_public_path__ + "static/media/credit_card_white_24dp.d281b371.svg";